import { Typography } from '@euler/app/components/typography';
import { SwitchButton } from '@euler/components/Switch';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { View } from 'react-native';
import { useOrderFlowContext } from '../../../../OrderFlowContext';

/** Sized down from `small`, to sit on a section header without dominating it. */
const kSwitchSize = { thumb: 16, margin: 1, borderRadius: 8 };

/**
 * Declares that the vehicle has no ISO VIN — Hong Kong and imported vehicles
 * still carry a chassis number instead. The VIN field then takes that number
 * and `vin` holds the placeholder, which is what the server keys on.
 */
export const NonStandardVinToggle = memo(
  ({ disabled }: { disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();
    const { rpx } = useResponsiveContext();

    const checked = form.isNonStandardVin.value;

    // Only the flag moves. Both numbers keep whatever was typed so flipping
    // back and forth loses nothing; which one the order carries is decided
    // when the request is built.
    const onChange = usePersistFn((value: boolean) => {
      form.isNonStandardVin.update(value);
      form.vin.setError(undefined);
      form.chassisNo.setError(undefined);
    });

    return (
      <View
        css={`
          flex-direction: row;
          align-items: center;
          margin-left: ${rpx(12)}px;
        `}
      >
        <Typography.Text
          color={theme.linkColor}
          size={rpx(11)}
          css={`
            margin-right: ${rpx(6)}px;
          `}
        >
          非标准VIN码
        </Typography.Text>
        <SwitchButton
          on={checked}
          size={kSwitchSize}
          rounded
          disabled={disabled}
          onChange={onChange}
        />
      </View>
    );
  },
);
